module.exports = __webpack_public_path__ + "static/media/ki.fbe824dc.svg";